export default {"src":"/_next/static/media/Group 48097638.afb40c0b.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};